<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="tech-offer-side flex flex-col items-center">
        <h3>Congrats! You been selected for a interview!</h3>
        <img src="@/assets/image/consultant_interview.png" alt="interview" />
        <div class="tech-offer-steps">
          <div class="flex active">
            <div class="tech-step-order">
              <span>1</span>
            </div>
            <div class="tech-step-info flex-1">Sign up for interview</div>
          </div>
          <div class="flex">
            <div class="tech-step-order">
              <span>2</span>
            </div>
            <div class="tech-step-info flex-1">We make your a offer</div>
          </div>
          <div class="flex">
            <div class="tech-step-order">
              <span>3</span>
            </div>
            <div
              class="tech-step-info flex-1"
            >You can accept offer to be a active consultant with us!</div>
          </div>
        </div>
      </div>
      <div class="tech-offer-main flex-1">
        <h3>Book your interview below</h3>
        <p>Book an availible slot and our tech will video chat you about both your experience and also ask your some technical questions to determine your aptitude</p>
        <iframe :src="caledlyUrl" frameborder="0" width="1000" height="700"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { db } from "@/vendor/firebase";
import * as config from "@/config";

export default {
  data() {
    return {
      consultant: null,
      caledlyUrl: null
    };
  },
  watch: {
    user: function() {
      this.bindData();
    },
    consultant: function() {
      this.onConsultantUpdated();
    }
  },
  computed: {
    ...mapState(["user"])
  },
  mounted: function() {
    this.$store.commit("closeSidebar");
    this.bindData();
    this.caledlyUrl = config.CALENDLY_URL;
  },
  methods: {
    bindData: function() {
      if (this.user.consultant && this.user.consultant.id) {
        const queryId = this.user.consultant.id;
        this.$bind("consultant", db.collection("consultants").doc(queryId));
      }
    },
    onConsultantUpdated: function() {
      if (this.consultant.application_status == "processing_interview") {
        this.$router
          .push("/home/consultant/consultant_processing_interview")
          .catch(err => {});
      }
    }
  }
};
</script>
